"use client";

import { useEffect, useState } from "react";
import { ComprehensiveMemoryDiagnostic } from "./ComprehensiveMemoryDiagnostic";

// Global state for widget visibility
let isWidgetVisible = false;
let setWidgetVisibility: ((visible: boolean) => void) | null = null;

export function MemoryDiagnosticWidget() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Register this component's setter
    setWidgetVisibility = setIsVisible;

    // Set initial visibility
    setIsVisible(isWidgetVisible);

    return () => {
      setWidgetVisibility = null;
    };
  }, []);

  // Only show in development mode
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-[9999]">
      <ComprehensiveMemoryDiagnostic onClose={() => toggleMemoryWidget()} />
    </div>
  );
}

// Function to toggle widget visibility from outside
export function toggleMemoryWidget() {
  isWidgetVisible = !isWidgetVisible;
  if (setWidgetVisibility) {
    setWidgetVisibility(isWidgetVisible);
  }
}

// Function to get current visibility state
export function isMemoryWidgetVisible() {
  return isWidgetVisible;
}
